import type { NavItem } from './types';

/**
 * Whether a nav item owns the page on screen. A host that knows the answer says so on the item
 * — a server-rendered page is tagged with the app it belongs to — and only a host that does not
 * falls back to reading it off the path.
 */
export function isNavItemActive(item: NavItem, currentPath: string): boolean {
  let active: boolean;
  if (item.selected === undefined) {
    if (item.exact) {
      active = currentPath === item.match;
    } else {
      active = currentPath.startsWith(item.match);
    }
  } else {
    active = item.selected;
  }
  return active;
}
